import { useState } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { useT } from "@/contexts/LanguageContext";

const TESTIMONIALS = [
  {
    quote: "Midemide handled our oversized HVAC rollout across three provinces without a single delay. The dispatch team picked up the phone every single time.",
    author: "Marcus Reilly",
    role: "Logistics Director, Northern Mechanical Group",
    industry: "Engineering",
  },
  {
    quote: "We needed a flatbed cross-border move with permits in 36 hours. They quoted in 20 minutes and delivered ahead of schedule. Now they handle all our heavy freight.",
    author: "Sandra Okafor",
    role: "VP Operations, Boreal Energy Systems",
    industry: "Energy",
  },
  {
    quote: "Custom cabinetry is fragile, expensive and time-sensitive. The team at MDLGX treats every shipment like it's their own. That's rare.",
    author: "Diego Marchetti",
    role: "Founder, Marchetti Architectural Cabinetry",
    industry: "Cabinetry",
  },
];

export default function Testimonials() {
  const { t } = useT();
  const [i, setI] = useState(0);
  const tst = TESTIMONIALS[i];

  return (
    <section data-testid="testimonials-section" className="section-pad bg-light relative overflow-hidden">
      <div className="container-mdgx">
        <div className="text-overline mb-4">{t("testimonials.overline")}</div>
        <h2 className="section-headline mb-16 max-w-4xl">
          {t("testimonials.headline")}
        </h2>

        <div className="border-t border-b py-16" style={{ borderColor: "#e7e5e0" }}>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
            <div className="md:col-span-1">
              <Quote className="text-[#D9633F]" size={48} strokeWidth={1.25} />
            </div>
            <div className="md:col-span-11">
              <p data-testid="testimonial-quote" className="font-display text-2xl md:text-4xl leading-tight tracking-tight max-w-4xl">
                "{tst.quote}"
              </p>
              <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3">
                <div>
                  <div className="font-display font-bold text-lg">{tst.author}</div>
                  <div className="text-neutral-600 text-sm mt-1">{tst.role}</div>
                </div>
                <div className="ml-auto flex items-center gap-3">
                  <div className="font-mono text-xs text-[#D9633F] tracking-[0.3em] uppercase">{tst.industry}</div>
                  <div className="flex items-center gap-2">
                    <button
                      data-testid="testimonial-prev"
                      onClick={() => setI((i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
                      className="w-10 h-10 border border-neutral-300 hover:border-[#D9633F] hover:text-[#D9633F] text-neutral-700 flex items-center justify-center transition-colors"
                      aria-label="Previous testimonial"
                    ><ChevronLeft size={18} /></button>
                    <button
                      data-testid="testimonial-next"
                      onClick={() => setI((i + 1) % TESTIMONIALS.length)}
                      className="w-10 h-10 border border-neutral-300 hover:border-[#D9633F] hover:text-[#D9633F] text-neutral-700 flex items-center justify-center transition-colors"
                      aria-label="Next testimonial"
                    ><ChevronRight size={18} /></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
